import { FC } from "react";

type Props = {
	children: React.ReactNode;
};

export const Text: FC<Props> = ({ children }) => {
	return (
		<p className='text-[35px] max-desktop:text-[20px] mb-[22px] font-[300] max-desktop:mb-[5px] whitespace-pre-line leading-[35px] max-desktop:leading-[23px]  text-justify tracking-[0.5px]'>
			{children}
		</p>
	);
};

export const TextMedium: FC<Props> = ({ children }) => {
	return (
		<p className='text-[35px] max-desktop:text-[20px] leading-[38px] max-desktop:leading-[22px] text-left font-[600] pt-[65px] pb-[31px] max-desktop:pt-[45px] max-desktop:pb-[20px] whitespace-pre-line tracking-[0.4px]'>
			{children}
		</p>
	);
};

export const TextBig: FC<Props> = ({ children }) => {
	return (
		<p className='text-[50px] max-desktop:text-[38px] font-[600] text-left pt-[100px] pb-[65px] max-desktop:pt-[59px] max-desktop:pb-[45px] whitespace-pre-line uppercase tracking-[1px] leading-[55px] max-desktop:leading-[40px]'>
			{children}
		</p>
	);
};
